import { render } from "./HouseLayout.vue?vue&type=template&id=95e89b20&scoped=true"
import script from "./HouseLayout.vue?vue&type=script&lang=js"
export * from "./HouseLayout.vue?vue&type=script&lang=js"

import "./HouseLayout.vue?vue&type=style&index=0&id=95e89b20&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\agat.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e89b20"]])

export default __exports__